
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCertificate } from "../firebase/database";

export default function VerifyCertificate() {
  const { certId } = useParams();
  const [cert, setCert] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchCert() {
      try {
        const data = await getCertificate(certId);
        if (data) {
          setCert(data);
        } else {
          setError("Certificate not found or invalid verification link.");
        }
      } catch (err) {
        console.error(err);
        setError("Error verifying certificate.");
      } finally {
        setLoading(false);
      }
    }
    fetchCert();
  }, [certId]);

  if (loading) return <div style={{ padding: 40, textAlign: "center", fontFamily: "DM Sans" }}>Verifying Certificate...</div>;

  if (error) {
    return (
      <div style={{ padding: 40, textAlign: "center", fontFamily: "DM Sans", color: "#EF4444" }}>
        <h2>Verification Failed</h2>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 600, margin: "40px auto", padding: 24, background: "#fff", borderRadius: 16, boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)", fontFamily: "DM Sans, sans-serif" }}>
      <div style={{ textAlign: "center", marginBottom: 32 }}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 20, marginBottom: 16 }}>
          {cert.photo && (
            <img src={cert.photo} alt="Student" style={{ width: 80, height: 100, objectFit: "cover", borderRadius: 8, border: "2px solid #10B981" }} />
          )}
          <div style={{ width: 64, height: 64, backgroundColor: "#10B981", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <svg style={{ width: 32, height: 32, color: "#fff" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
        </div>
        <h2 style={{ color: "#065F46", margin: 0 }}>Certificate Verified</h2>
        <p style={{ color: "#6B7280" }}>This certificate is authentic and was issued by Pankaj Computers.</p>
      </div>

      <div style={{ display: "grid", gap: 16 }}>
        <div style={{ padding: "12px 0", borderBottom: "1px solid #F3F4F6" }}>
          <span style={{ fontSize: 12, color: "#6B7280", textTransform: "uppercase", fontWeight: 600 }}>Student Name</span>
          <div style={{ fontSize: 18, color: "#111827", fontWeight: 500 }}>{cert.studentName}</div>
        </div>
        <div style={{ padding: "12px 0", borderBottom: "1px solid #F3F4F6" }}>
          <span style={{ fontSize: 12, color: "#6B7280", textTransform: "uppercase", fontWeight: 600 }}>Course Completed</span>
          <div style={{ fontSize: 18, color: "#111827", fontWeight: 500 }}>{cert.courseName}</div>
        </div>
        <div style={{ padding: "12px 0", borderBottom: "1px solid #F3F4F6" }}>
          <span style={{ fontSize: 12, color: "#6B7280", textTransform: "uppercase", fontWeight: 600 }}>Skills</span>
          <div style={{ fontSize: 16, color: "#111827" }}>{cert.skills}</div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
          <div style={{ padding: "12px 0", borderBottom: "1px solid #F3F4F6" }}>
            <span style={{ fontSize: 12, color: "#6B7280", textTransform: "uppercase", fontWeight: 600 }}>Certificate No.</span>
            <div style={{ fontSize: 16, color: "#111827" }}>{cert.certNo}</div>
          </div>
          <div style={{ padding: "12px 0", borderBottom: "1px solid #F3F4F6" }}>
            <span style={{ fontSize: 12, color: "#6B7280", textTransform: "uppercase", fontWeight: 600 }}>Issue Date</span>
            <div style={{ fontSize: 16, color: "#111827" }}>{cert.date}</div>
          </div>
        </div>

        {cert.signatories && cert.signatories.length > 0 && (
          <div style={{ padding: "12px 0", borderBottom: "1px solid #F3F4F6" }}>
            <span style={{ fontSize: 12, color: "#6B7280", textTransform: "uppercase", fontWeight: 600 }}>Signing Authorities</span>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 16, marginTop: 8 }}>
              {cert.signatories.map((sig, idx) => (
                <div key={idx} style={{ flex: "1 1 150px" }}>
                  <div style={{ fontSize: 14, color: "#111827", fontWeight: 600 }}>{sig.name}</div>
                  <div style={{ fontSize: 12, color: "#6B7280" }}>{sig.designation}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div style={{ marginTop: 32, textAlign: "center", paddingTop: 24, borderTop: "2px dashed #E5E7EB" }}>
        <div style={{ fontSize: 14, color: "#111827", fontWeight: 600 }}>PANKAJ COMPUTERS</div>
        <div style={{ fontSize: 12, color: "#6B7280" }}>Anupgarh, Rajasthan, India</div>
        <a href="https://pankajcomputers.com" style={{ fontSize: 12, color: "#2563EB", textDecoration: "none" }}>www.pankajcomputers.com</a>
      </div>
    </div>
  );
}
